import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Field, reduxForm, Form, change} from 'redux-form'
import CustomSelect from "views/Components/CustomSelect.jsx"
import ValidatedCustomInput from "views/Components/ValidatedCustomInput.jsx"
import moment from 'moment'
import withStyles from "@material-ui/core/styles/withStyles";
import styles from "assets/jss/material-dashboard-pro-react/views/form";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// icons
import AttachMoney from "@material-ui/icons/AttachMoney";

import {required} from 'views/utils/validations'

import {
  adjustmentSave,
  adjustmentsFetch,
  adjustmentFetch,
} from 'actions/adjustments'

import {
  adjustmentsReasonsFetchAll
} from 'actions/adjustmentsReasons'

import {
  danger,
  success,
} from 'actions/notification'

import {
  ibsFetchAll,
  ibFetch,
  ibFilter
} from 'actions/ibs'



const validate = values => {

 const errors = {}

 const requiredFields = [

'amount',
'usdAmount',
'ibId',
'reasonId',
'description',

 ]

if (!values.usdAmount) {
    errors.usdAmount = 'Required'
  } else if (!/^-?[0-9]\d*(\.\d+)?$/g.test(values.usdAmount)) {
             
    errors.usdAmount = 'Invalid Number for Amount'
  }

 requiredFields.forEach(field => {

 if (!values[field]) {

 errors[field] = 'Required'

 }

 })

 

 return errors

}

class CreateEdit extends Component {
   constructor(props) {
    super(props);
    this.state = {
      ibList: [],
      maxAmount: 0,
      selectedIb: {},
      usdAmount: 0,
      }
    }


    componentWillMount(){
    this.amountChange = this.amountChange.bind(this)
    this.datetimeChange = this.datetimeChange.bind(this)
    this.incrementAmount = this.incrementAmount.bind(this);
    this.decrementAmount = this.decrementAmount.bind(this);
    }
		componentDidMount(){
      this.props.ibFilter({size: 10000000})
      this.props.ibsFetchAll();
      this.props.adjustmentsReasonsFetchAll();
      this.props.change('usdAmount', 0);

      this.props.ibsFetchAll().then(e=>{

          this.setState({
          ...this.state,
          ibList:e,
        })

    });

    }
		getInput(data) {
      return <Field
              name={data.key}
              placeholder={data.name}
              id={data.key}
              icon={data.icon}
              type={data.type}
              props={{
                name: data.key
              }}
              validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
            />
    }
    getInputNumber(data) {
			return <Field
							name={data.key}
							placeholder={data.name}
							id={data.key}
              icon={data.icon}
              type="number"
							props={{
								name: data.key
							}}
							validate={data.validate ? data.validate : []}
              component={ValidatedCustomInput}
              max={0}
              min={0}
						/>
		}
		
    submit(values){
      
      values['time'] = Date.parse(moment.utc(new Date()).format());
      //values['changeStatusTime'] = Date.parse(moment.utc(values['time']).format());
      values['changeStatusTime'] = Date.parse(moment.utc(values['time']).format());
      values.approvingUserId = this.props.auth.userId;

			this.props.save(values)
				.then(e=>{
					this.props.success(e.adjustmentId + ' Added',4)
					this.props.fetchAll()
					this.props.history.goBack()
				})
				.catch(e=>{this.props.danger(e+'',4);})
    }

    ibChange(ev) {
     
      const ib = ev.target.value
      this.props.ibFetch(ib).then((ib) => {
        this.setState({...this.state, selectedIb: ib})
       
      })
    }
    
    datetimeChange(ev) {
      this.setState({...this.state, time: ev})
      this.props.change('time', ev);
    }

    incrementAmount() {
      
      this.setState((state) => {
        return {usdAmount: parseInt(parseInt(state.usdAmount,10)+1,10)}
      });

      this.props.change('usdAmount', this.state.usdAmount);

    }

    decrementAmount() {
     
      this.setState((state) => {
        return {usdAmount: parseInt(parseInt(state.usdAmount,10)-1,10)}
      });

      this.props.change('usdAmount', this.state.usdAmount);
    
    }

    amountChange(e) {

      this.setState((state) => {
        return {usdAmount: e.target.value}
      });

      this.props.change('usdAmount', this.state.usdAmount);

    }
    handleChange = name => event => {
      this.setState({ [name]: event.target.value });
    };

    render(){
    const {classes, ibs, handleSubmit,adjustmentReasons} = this.props
    const { ibList } = this.state;

    return(
      <GridContainer justify="center">
        <GridItem xs={12} sm={8}>
          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit(this.submit.bind(this))}>
                <GridContainer justify="center">

                  <GridItem xs={12} sm={12}>
                    <h4 className={classes.infoText}>
                      Adjustment
                    </h4>
                  </GridItem>
                  {/*<GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                 
              
                      <InputLabel className={classes.label}>Date Time</InputLabel>
                      <br />
                      <FormControl fullWidth>
                        <Datetime
                          id="time"
                          name="time"
                          props={{
                            name:"time"
                          }}
                          timeFormat={true}
                          icon={<CalendarToday className={this.props.classes.inputAdornmentIcon}/>}
                          inputProps={{
                          id:"time",
                          name:"time",
                          readOnly:true,
                        endadornment: (
                          <InputAdornment
                            position="end"
                            className={classes.inputAdornment}
                          >
                            <CalendarToday className={this.props.classes.inputAdornmentIcon}/>
                          </InputAdornment>
                        )
                      }}
                      onChange={(ev) => this.datetimeChange(ev)}
                      validate={[required]}
                      component={CustomInput}
                    />
                    </FormControl>
                </GridItem>*/}
                { ibList.length &&
               <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                 
                 <Field
                      name="ibId"
                      options={ibList.map((i) => {return {value: i.ibId, label: `${i.firstName} ${i.lastName} (${i.ibId})`}})}
                      placeholder="IB Name*"
                      id="ibId"
                      props={{
                        id:"ibId",
                        name:"ibId"
                      }}
                      onChange={(ev) => this.ibChange(ev)}
                      validate={[required]}
                      component={CustomSelect}
                    />
                      
                </GridItem>
                }
                  <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="reasonId"
                      options={adjustmentReasons.map((i) => {return {value: i.adjustmentReasonId, label: `${i.name}`}})}
                      placeholder="Reason of Adjustments"
                      id="reasonId"
                      props={{
                        id:"reasonId",
                        name:"reasonId"
                      }}
                      validate={[required]}
                      component={CustomSelect}
                    />
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    <Field
                      name="description"
                      placeholder="Period of Adjustment"
                      id="description"
                      props={{
                        name:"description"
                      }}
                      validate={[required]}
                      component={ValidatedCustomInput}
                    />
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={12} lg={10}>
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={1} lg={1}><br/></GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={2} lg={2}>
                    <Button color="white" onClick={this.incrementAmount}><h4>+</h4></Button><Button color="white" onClick={this.decrementAmount}><h4>-</h4></Button>
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={10} lg={8}>
                    {<Field
                        type="text"
                        name="usdAmount"
                        label={`Enter Amount :`}
                        placeholder={'Amount in USD'}
                        id="usdAmount"
                        props={{
                          name:"usdAmount",
                        }}
                        icon={<AttachMoney className={this.props.classes.inputAdornmentIcon}/>}
                        onChange={(ev) => this.amountChange(ev)}
                        value={this.state.usdAmount}
                       
                        validate={[required]}
                        disabled={false}
                        component={ValidatedCustomInput}
                      ></Field>}
                      
                    </GridItem>
                    <GridItem style={{marginTop:"25px"}} xs={12} sm={12} md={6} lg={6}>
                   
                   
                    </GridItem>
                   

                  <GridItem xs={12} sm={12} md={12} lg={10}>
                      
                      <Button type="submit"  className={classes.submit} color="success">Submit</Button>
                      <Button type="cancel"  className={classes.submit} color="danger">Cancel</Button>
                  </GridItem>
                </GridContainer>
              </Form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
      )
  }
}

function mapStateToProps(state) {
  return {
    auth:state.auth,
    ibs: state.ibs.list,
    adjustmentReasons: state.adjustmentsReasons.listAll,
    adjustments: state.adjustments.list,
    withdrawalForm: state.form.createCreateEditForm
	}
}

function mapDispatchToProps(dispatch) {
	return {
		fetch:(id)=>dispatch(adjustmentFetch(id)),
		fetchAll:() => dispatch(adjustmentsFetch()),
		save:(data)=>dispatch(adjustmentSave(data)),
		danger:(text,sec)=>dispatch(danger(text,sec)),
		success:(text,sec)=>dispatch(success(text,sec)),
    ibsFetchAll: () => dispatch(ibsFetchAll()),
    ibFilter: (filter) => dispatch(ibFilter(filter)),
    ibFetch: (ib) => dispatch(ibFetch(ib)),
    change: (field, value) => dispatch(change('createCreateEditForm', field, value)),
    adjustmentsReasonsFetchAll: () => dispatch(adjustmentsReasonsFetchAll())
	}
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'createCreateEditForm', validate })(CreateEdit)))



// WEBPACK FOOTER //
// ./src/views/Adjustments/CreateEdit.jsx